import React from 'react';

const OutOfStockModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ textAlign: 'center', maxWidth: '380px' }}>
        <button className="modal-close" onClick={onClose}>×</button>
        <div style={{ fontSize: '40px', marginBottom: '12px' }}>😔</div>
        <h2 style={{ marginBottom: '8px' }}>Out of Stock</h2>
        <p style={{ color: '#718096', marginBottom: '24px' }}>
          Sorry, this item is currently out of stock. Please check back later.
        </p>
        <button className="btn btn-primary" onClick={onClose} style={{ width: '100%' }}>
          Got it
        </button>
      </div>
    </div>
  );
};

export default OutOfStockModal;
